import { position_name } from './config';

export const reducerPhotoCode = (code) => {
  switch ((code = parseInt(code))) {
    case 1:
    case 2:
    case 3:
      return code;

    case 4:
      return 4;

    case 5:
      return 10;

    case 6:
      return 5;

    case 7:
      return 11;

    case 8:
      return 7;

    case 9:
      return 12;

    case 10:
      return 8;

    case 11:
      return 13;

    case 12:
      return 9;

    case 13:
      return 6;

    case 14:
      return 15;

    default:
      return;
  }
};
export const reducerPhotoCodeReverse = (code) => {
  switch ((code = parseInt(code))) {
    case 1:
    case 2:
    case 3:
    case 4:
      return code;

    case 5:
      return 6;

    case 6:
      return 13;

    case 7:
      return 8;

    case 8:
      return 10;

    case 9:
      return 12;

    case 10:
      return 5;

    case 11:
      return 7;

    case 12:
      return 9;

    case 13:
      return 11;

    case 15:
      return 14;

    default:
      return;
  }
};

export const reducePhotoCodeUpload = {
  [position_name['VIN']]: 1,
  [position_name['INTERIOR']]: 2,
  [position_name['ODOMETER']]: 3,
  [position_name['LEFT_VIEW']]: 4,
  [position_name['FRONT_LEFT']]: 10,
  [position_name['FRONT_VIEW']]: 5,
  [position_name['FRONT_RIGHT']]: 11,
  [position_name['RIGHT_VIEW']]: 7,
  [position_name['REAR_RIGHT']]: 12,
  [position_name['REAR_VIEW']]: 8,
  [position_name['REAR_LEFT']]: 13,
  [position_name['WINDSHIELD']]: 9,
  [position_name['TIRE']]: 6,
  [position_name['REAR_TIRE']]: 15,
};
// export const reducePhotoCodeUpload = (position) => {
//   switch (position) {
//     case position_name['VIN']:
//       return 1;
//     case position_name['INTERIOR']:
//       return 2;
//     case position_name['ODOMETER']:
//       return 3;
//     case position_name['LEFT_VIEW']:
//       return 4;
//     case position_name['FRONT_LEFT']:
//       return 10;
//     case position_name['FRONT_VIEW']:
//       return 5;
//     case position_name['FRONT_RIGHT']:
//       return 11;
//     case position_name['RIGHT_VIEW']:
//       return 7;
//     case position_name['REAR_RIGHT']:
//       return 12;
//     case position_name['REAR_VIEW']:
//       return 8;
//     case position_name['REAR_LEFT']:
//       return 13;
//     case position_name['WINDSHIELD']:
//       return 9;
//     case position_name['TIRE']:
//       return 6;
//     default:
//       break;
//   }
// };

export const handleViewSize = (view) => {
  let pixel = '';
  switch (view) {
    case position_name['INTERIOR']:
      pixel = '45%';
      break;
    case position_name['LEFT_VIEW']:
      pixel = '90%';
      break;
    case position_name['RIGHT_VIEW']:
      pixel = '90%';
      break;
    case position_name['FRONT_VIEW']:
      pixel = '100%';
      break;
    case position_name['REAR_VIEW']:
      pixel = '100%';
      break;
    case position_name['VIN']:
      pixel = '60%';
      break;

    default:
      pixel = '80%';
      break;
  }
  return pixel;
};
